module.exports = sector;